import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { Ptag } from "./core";
import { useLocation } from "react-router-dom";
import routes from "./routes";
import { useNavigate } from "react-router-dom";
import http from "../services/httpService";
import { theme } from "theme";
import { healthIssuancePresent, logoutHandler } from "utlis/utils";
import { CutoffDate } from "pages/FlexSetup/Dashboard/styles";

const SideNavContent = ({
  planEditable = false,
  onlyShowLogout = false,
  showCB,
  showCS,
  dashboardCtaData,
}) => {
  const [permissions, setPermissions] = useState({});
  const [policyDoc, setPolicyDoc] = useState(true);
  const [showBuffer, setShowBuffer] = useState(false);
  const { pathname } = useLocation();
  const [uhidExists, setUhidExists] = useState(false);
  const [cutOffDatePassed, setCutOffDatePassed] = useState(false);
  const [dcCollection, setDcCollection] = useState(null);
  const [dcTasksetId, setDcTasksetId] = useState(null);
  const [dataCollectionAllowed, setDataCollectionAllowed] = useState(false);
  const [showClaimCTA, setShowClaimCTA] = useState(false)
  const [gmcDetails, setGmcDetails] = useState(
    localStorage.getItem("gmc_details")
  );
  dashboardCtaData &&
    localStorage.setItem("dasboard_cta_data", JSON.stringify(dashboardCtaData));
  const flex = JSON.parse(localStorage.getItem("universal_product"));
  useEffect(() => {
    if (dashboardCtaData) {
      setStateData(dashboardCtaData);
    } else {
      const local_data = JSON.parse(localStorage.getItem("dasboard_cta_data"));
      setStateData(local_data);
    }
  }, [dashboardCtaData]);
  const setStateData = (data) => {
    const {
      uhid_exists,
      cut_off_date_passed,
      dc_collection,
      dc_taskset_id,
      collection_allowed,
    } = data;
    setUhidExists(uhid_exists);
    setCutOffDatePassed(cut_off_date_passed);
    setDcCollection(dc_collection);
    setDcTasksetId(dc_taskset_id);
    setDataCollectionAllowed(collection_allowed);
  };

  const navigate = useNavigate();
  useEffect(() => {
    const employeeEditPermissions = JSON.parse(
      localStorage.getItem("employeeEditPermissions") || "{}"
    );
    setPermissions(employeeEditPermissions);
    const showBuffer =
      showCB ?? localStorage.getItem("show_buffer_data") === "true";
    setShowBuffer(showBuffer);
    const show_claim_summary = JSON.parse(localStorage.getItem("show_claim_summary"))
    if(show_claim_summary || showCS) {
      setShowClaimCTA(true)
    }
  }, [gmcDetails, showCB, showCS]);

  const commonButtonFlexGmc = () => {
    const gmc = localStorage.getItem("flow") == "GMC";
    const flex = localStorage.getItem("flow") == "FLEX";
    if (gmc || flex) {
      return true;
    } else {
      return false;
    }
  };

  const currentRoute = pathname && pathname.replace("/", "");
  const getData = async () => {
    const { data } = await http.get(
      `/business/userplans/${localStorage.getItem("userplan_id")}/`
    );
    data && data["policy_doc_url"] ? setPolicyDoc(true) : setPolicyDoc(false);
  };

  const onClickEditEmployees = () => {
    if (permissions?.showPopUp) {
      alert(permissions?.notification);
    } else {
      navigate(`/${routes.UPLOAD_EXCEL}/add`);
    }
  };
  const setshowUploadPolicyDoc = () => {
    if (
      localStorage.getItem("insurer") == "go_digit" &&
      !localStorage.getItem("policy_doc_url") &&
      !isPlanEditable
    ) {
      return true;
    } else {
      return false;
    }
  };
  const planEditableLS = JSON.parse(
    localStorage.getItem("isPlanEditable") || "false"
  );
  const isPlanEditable = planEditableLS || planEditable;

  const getButtonColor = (route) => {
    if (currentRoute.indexOf(route) > -1) {
      return theme.whiteColor;
    }
    return "#cacaca";
  };
  const handleTabClick = (event, page) => {
    const disable = disableButton(page);
    if (disable) {
      event.preventDefault(); // Prevent redirection
    }
  };

  const disableButton = (cta) => {
    return false;
    //dashboard CTA will be available for user to update any date after company setup
    if (uhidExists) {
      return false;
    }
    if (flex) {
      if (
        cutOffDatePassed === true &&
        (cta === "UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID" ||
          cta == "EMPLPLOYEE_DATA_COLLECTION_HISTORY")
      ) {
        return false;
      } else if (
        cutOffDatePassed === false &&
        cta === "EMPLPLOYEE_DATA_COLLECTION_HISTORY"
      ) {
        return false;
      }
    }
    if (!flex) {
      if (
        cutOffDatePassed == null &&
        cta === "UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID"
      ) {
        return false;
      } else if (
        cta === "UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID" ||
        cta === "EMPLPLOYEE_DATA_COLLECTION_HISTORY"
      ) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  };

  return (
    <>
      {!onlyShowLogout ? (
        <>
          <TabsWrapper>
            <>
              <Tab href={`/${routes.CARE_DASHBOARD}`}>
                <Ptag
                  textAlign="left"
                  fontSize="18px"
                  letterHeight="26px"
                  color={getButtonColor(routes.CARE_DASHBOARD)}
                  fontWeight="500"
                >
                  Overview
                </Ptag>
              </Tab>
              {showBuffer && (
                <Tab
                  href={`/${routes.VIEW_CORPORATE_BUFFER}`}
                  disabled={disableButton("VIEW_CORPORATE_BUFFER")}
                  onClick={(e) => handleTabClick(e, "VIEW_CORPORATE_BUFFER")}
                >
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    color={getButtonColor(routes.VIEW_CORPORATE_BUFFER)}
                    fontWeight="500"
                  >
                    View Corporate Buffer
                  </Ptag>
                </Tab>
              )}
              {commonButtonFlexGmc() && (
                <Tab
                  href={`/${routes.VIEW_CD_BALANCE}`}
                  disabled={disableButton("VIEW_CD_BALANCE")}
                  onClick={(e) => handleTabClick(e, "VIEW_CD_BALANCE")}
                >
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    color={getButtonColor(routes.VIEW_CD_BALANCE)}
                    fontWeight="500"
                  >
                    Cash Deposit Account
                  </Ptag>
                </Tab>
              )}
              {(setshowUploadPolicyDoc() || commonButtonFlexGmc()) && (
                <Tab
                  href={`/${routes.UPLOADPOLICYDOC}`}
                  disabled={disableButton("VIEW_CD_BALANCE")}
                  onClick={(e) => handleTabClick(e, "VIEW_CD_BALANCE")}
                >
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    fontWeight="500"
                    color={getButtonColor(routes.UPLOADPOLICYDOC)}
                  >
                    Upload Policy Document
                  </Ptag>
                </Tab>
              )}
              {
                // setshowUploadPolicyDoc() &&
                !isPlanEditable && commonButtonFlexGmc() && (
                  <Tab
                    href={`/${routes.UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID}`}
                    disabled={disableButton(
                      "UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID"
                    )}
                    onClick={(e) =>
                      handleTabClick(e, "UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID")
                    }
                  >
                    <Ptag
                      textAlign="left"
                      fontSize="18px"
                      letterHeight="26px"
                      fontWeight="500"
                      color={getButtonColor(
                        routes.UNIVERSAL_POST_ISSUANCE_UPLOAD_UHID
                      )}
                    >
                      Upload Enrolments
                    </Ptag>
                  </Tab>
                )
              }
              {!isPlanEditable && commonButtonFlexGmc() && (
                <Tab
                  href={`/${routes.GMC_PAYMENTSUMMARY}`}
                  disabled={disableButton("GMC_PAYMENTSUMMARY")}
                  onClick={(e) => handleTabClick(e, "GMC_PAYMENTSUMMARY")}
                >
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    fontWeight="500"
                    color={getButtonColor(routes.GMC_PAYMENTSUMMARY)}
                  >
                    Enrolment History
                  </Ptag>
                </Tab>
              )}
              {!isPlanEditable && commonButtonFlexGmc() && showClaimCTA && (
                <Tab
                  href={`/${routes.CLAIM_DASHBOARD}`}
                  disabled={disableButton("CLAIM_DASHBOARD")}
                  onClick={(e) => handleTabClick(e, "CLAIM_DASHBOARD")}
                >
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    fontWeight="500"
                    color={getButtonColor(routes.CLAIM_DASHBOARD)}
                  >
                    Claims Summary
                  </Ptag>
                </Tab>
              )}
              {!flex && <Tab
                href={`/${routes.UNIVERSAL_BENEFITS_SETUP}?path=add`}
                onClick={(e) => handleTabClick(e, "GMC_PAYMENTSUMMARY")}
              >
                <Ptag
                  textAlign="left"
                  fontSize="18px"
                  letterHeight="26px"
                  fontWeight="500"
                  color={getButtonColor(routes.UNIVERSAL_BENEFITS_SETUP)}
                >
                  Add Products
                </Ptag>
              </Tab>}
              <Tab
                  href={`/${routes.UTILITIES}`}
                >
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    fontWeight="500"
                    color={getButtonColor(routes.UTILITIES)}
                  >
                    Utilities
                  </Ptag>
                </Tab>
              {dataCollectionAllowed && (
                <Tab href={`/${routes.EMPLOYEE_DATA_COLLECTION}`}>
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    fontWeight="500"
                    color={getButtonColor(routes.EMPLOYEE_DATA_COLLECTION)}
                  >
                    Collect Employee Data
                  </Ptag>
                </Tab>
              )}
              ) (
              {dataCollectionAllowed && (
                <Tab
                  href={`/${routes.EMPLPLOYEE_DATA_COLLECTION_HISTORY}`}
                  disabled={disableButton("EMPLPLOYEE_DATA_COLLECTION_HISTORY")}
                  onClick={(e) =>
                    handleTabClick(e, "EMPLPLOYEE_DATA_COLLECTION_HISTORY")
                  }
                >
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    fontWeight="500"
                    color={getButtonColor(
                      routes.EMPLPLOYEE_DATA_COLLECTION_HISTORY
                    )}
                  >
                    Data Collection History
                  </Ptag>
                </Tab>
              )}
              )
              {
                <Tab href={`/${routes.COMPANY_SETUP}/edit`}>
                  <Ptag
                    textAlign="left"
                    fontSize="18px"
                    letterHeight="26px"
                    fontWeight="500"
                    color={getButtonColor(routes.COMPANY_SETUP)}
                  >
                    Profile
                  </Ptag>
                </Tab>
              }
            </>

            <Tab onClick={() => logoutHandler(navigate)}>
              <Ptag
                textAlign="left"
                fontSize="18px"
                letterHeight="26px"
                fontWeight="500"
                color="#cacaca"
              >
                Logout
              </Ptag>
            </Tab>
          </TabsWrapper>
        </>
      ) : (
        <TabsWrapper>
          <Tab onClick={() => logoutHandler(navigate)}>
            <Ptag
              textAlign="left"
              fontSize="18px"
              letterHeight="26px"
              fontWeight="500"
              color="#cacaca"
            >
              Logout
            </Ptag>
          </Tab>
        </TabsWrapper>
      )}
    </>
  );
};

export default SideNavContent;

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  overflow: auto;
`;

export const Tab = styled.a`
  cursor: pointer;
  margin: 0 0.5rem;
  padding: 20px 4rem;
  text-decoration: none;
  transition: 0.2s ease-in-out all;
  border-radius: 6px;

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        background: linear-gradient(
          to right,
          #f52d6b 5px,
          rgba(173, 154, 255, 0.23) 5px 100%
        );
      }
      & p {
        transition: 0.2s ease-in-out all;
      }
      &:hover p {
        transform: translateX(7px);
      }
    `};
`;
